/** States of a traffic light (red/yellow/green) */
export enum TrafficLightState {
  Red = 'red',
  Yellow = 'yellow',
  Green = 'green',
}
